import { useState } from 'react';
import Overlay from '../ui/Overlay';
import { IconQuestion } from '../../assets/icons';

const AccountIncludedTooltip = () => {
    const [showTooltip, setShowTooltip] = useState(false)

    return (
        <div style={{position: 'relative', display: 'inline-block', verticalAlign: 'super', alignSelf: 'flex-start'}}>
            <button className="button-unstyled" onClick={() => setShowTooltip(true)}>
                <IconQuestion fill="#fff" />
            </button>

            {showTooltip && (
                <Overlay
                    headerTitle={"Accounts Included in Budget"}
                    onClose={() => setShowTooltip(false)}
                >
                    <p>
                        Accounts included in your budget are reflected in your budget calculations. In most cases, if you have a checking account that you use for everyday expenses, you will want to include it in your budget. If you have a credit card that you pay off in full each month, you may <em style={{fontStyle: 'italic'}}>not</em> want to include its available balance in your budget.
                    </p>

                    <p>
                        When viewing your account details, you can choose to include an account in your budget by checking the box labeled "Include Available Balance in Budget Funds". When this box is checked, it will be reflected in the "Available Balance" shown in your budget.
                    </p>

                    <p>
                        When you check the box to show accounts included in your budget, only accounts that are included in your budget will be displayed.
                    </p>

                    <h4>Our Recommendation:</h4>

                    <ul style={{
                        listStyleType: 'disc',
                        marginLeft: '1.5rem',
                        marginTop: '0.5rem'
                    }}>
                        <li>
                            If you have a primary checking account out of which your everyday expenses are paid, you should include its available balance in your budget.
                        </li>
                        <li>
                            If you have a credit card that you pay off in full each month, you may not want to include its available balance in your budget.
                        </li>
                    </ul>
                </Overlay>
            )}
        </div>
    )
}

export default AccountIncludedTooltip;